import { render } from "./paperDownloadPreview.vue?vue&type=template&id=3522278e&scoped=true"
import script from "./paperDownloadPreview.vue?vue&type=script&lang=js"
export * from "./paperDownloadPreview.vue?vue&type=script&lang=js"

import "./paperDownloadPreview.vue?vue&type=style&index=0&id=3522278e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3522278e"]])

export default __exports__